import React, { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export default function Account() {
  const { user, login, logout, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    setOrdersLoading(true);
    axios.get(`${API}/orders/mine`).then((r) => setOrders(r.data)).finally(() => setOrdersLoading(false));
  }, [user]);

  if (loading) return <div className="pt-40 text-center label-mono">Loading…</div>;

  if (!user) {
    return (
      <div className="max-w-[560px] mx-auto px-6 pt-40 pb-24 text-center" data-testid="signin-page">
        <div className="label-mono mb-4">Account</div>
        <h1 className="font-serif text-5xl">Sign in to continue.</h1>
        <p className="mt-4 text-[var(--text-secondary)]">Track your orders and save your favourite blends.</p>
        <button onClick={login} className="btn-primary mt-8" data-testid="signin-google-btn">Continue with Google</button>
      </div>
    );
  }

  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-12 pt-32 pb-24">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <div>
          <div className="label-mono mb-3">Your Account</div>
          <h1 className="font-serif text-5xl md:text-6xl leading-none tracking-tighter">Hello, {user.name?.split(" ")[0]}.</h1>
          <div className="mt-2 label-mono text-[var(--text-muted)]">{user.email}</div>
        </div>
        <div className="flex gap-3">
          {user.role === "admin" && <Link to="/admin" className="btn-outline">Control Room</Link>}
          <button onClick={logout} className="btn-outline" data-testid="account-logout">Sign out</button>
        </div>
      </div>

      <div className="border border-[var(--border)] bg-[var(--surface)]">
        <div className="border-b border-[var(--border)] px-6 py-4 label-mono">Order History</div>
        {ordersLoading && <div className="p-6 label-mono">Loading orders…</div>}
        {!ordersLoading && orders.length === 0 && (
          <div className="p-8 text-center text-[var(--text-secondary)]">
            <div className="font-serif text-2xl">No orders yet.</div>
            <Link to="/shop" className="label-mono link-underline mt-3 inline-block">Start with a blend →</Link>
          </div>
        )}
        {orders.map((o) => (
          <div key={o.id} className="border-b border-[var(--border)] last:border-b-0 px-6 py-5 grid grid-cols-1 md:grid-cols-5 gap-3" data-testid={`order-${o.id}`}>
            <div>
              <div className="label-mono text-[10px]">Order</div>
              <div className="font-mono text-sm">{o.id}</div>
            </div>
            <div>
              <div className="label-mono text-[10px]">Placed</div>
              <div className="text-sm">{new Date(o.created_at).toLocaleDateString()}</div>
            </div>
            <div>
              <div className="label-mono text-[10px]">Items</div>
              <div className="text-sm">{o.items.length}</div>
            </div>
            <div>
              <div className="label-mono text-[10px]">Status</div>
              <div className="text-sm uppercase text-[var(--primary)]">{o.status}</div>
            </div>
            <div className="text-right">
              <div className="label-mono text-[10px]">Total</div>
              <div className="font-mono text-lg text-[var(--primary)]">₹{o.total}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
